import { AOFL_PRODUCT_NAMES, REG_PATH_KEYS, REG_PATH_STEPS } from '$lib/utils/constants';
import { has2_0Account } from '$lib/utils/aofl-accounts';
import { get } from 'svelte/store';
import { user } from '$lib/stores/user/store.js';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	inApp: {
		condition: async (config) => {
			return config?.global?.appProduct !== AOFL_PRODUCT_NAMES.ABCMOUSE_2_0 && config.meta.inApp;
		},
		resolve: async () => await import('../../inside-pw/_in-app/Page.svelte'),
	},
	inApp2_0: {
		condition: async (config) => {
			return config?.global?.appProduct === AOFL_PRODUCT_NAMES.ABCMOUSE_2_0 && config.meta.inApp;
		},
		resolve: async () => await import('../_in_app_2-0/Page.svelte'),
	},
	browserIOSAltPayment1_0Subscriber: {
		condition: async () => {
			const { subscription_path, completed_step } = get(user).userMetaData;
			return (
				subscription_path === REG_PATH_KEYS.IOS_ALT_PAYMENT_SUBSCRIBER_1_0 &&
				completed_step !== REG_PATH_STEPS.COMPLETE
			);
		},
		resolve: async () => await import('../_browser/Page.svelte'),
	},
	browser_walmart: {
		condition: async (config) => config.meta.isOnnDevice === true,
		resolve: async () => await import('../_browser-walmart/Page.svelte'),
	},
	browserAndroidAltPaymentSubscriber: {
		condition: async () => {
			const subscription_path = get(user).userMetaData?.subscription_path;
			return (
				subscription_path === REG_PATH_KEYS.ANDROID_ALT_PAYMENT_SUBSCRIBER_1_0 ||
				subscription_path === REG_PATH_KEYS.ANDROID_ALT_PAYMENT_RESUBSCRIBER_1_0 ||
				subscription_path === REG_PATH_KEYS.ANDROID_ALT_PAYMENT_SUBSCRIBER_2_0 ||
				subscription_path === REG_PATH_KEYS.ANDROID_ALT_PAYMENT_RESUBSCRIBER_2_0
			);
		},
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
	browser1_0_User: {
		condition: async () => {
			return !has2_0Account();
		},
		resolve: async () => await import('../_browser/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
};

export { pageConditions };
